export enum CRM_ACTIONS {
   LIST_ALL = 'list-all',
   USER_DETAIL = 'user-detail',
   RESERVATION_DETAIL = 'reservation-detail',
}
